/**
 * Shared display formatters — one convention per figure, every page.
 *
 * F4 (numbers audit 2026-09-03): the same Google conversions rendered as 83 on
 * the Dashboard platform table (Math.round) and 82.82 on Campaigns (2-dp cap).
 * Both sides had a documented argument; what was wrong was disagreeing. The
 * 2-dp convention wins because Google's weighted/view-through/modeled
 * conversions ARE fractional — rounding invents a whole event that was never
 * reported — while whole-number platforms (Facebook/TikTok) render unchanged.
 */

/** Conversions: up to 2 decimals, no trailing zeros, nullish/NaN as 0. */
export const formatConversions = (n: number | null | undefined): string =>
  (Number.isFinite(n as number) ? (n as number) : 0).toLocaleString('en-US', {
    maximumFractionDigits: 2,
  });
